import styled from 'styled-components'

export default {
	Wrapper: styled.main`
		width: ${({$width}) => {
			if ($width === 'fit-content') return 'fit-content'
			if ($width) return $width
			return '100%'
		}};
		display: flex;
		flex-direction: column;
		gap: ${({$small}) => ($small ? '8px' : '16px')};

		& > h2 {
			${({theme, $small}) =>
				$small ? theme.font.small_bold : theme.font.medium_bold};

			& > span {
				color: ${({theme}) => theme.color.major};
			}
		}
	`,

	InputDiv: styled.div`
		display: flex;
		padding-bottom: ${({$small}) => ($small ? '8px' : '12px')};
		border-bottom: 1px solid ${({theme}) => theme.color.grey3};
		gap: ${({$small}) => ($small ? '6px' : '8px')};

		& > input {
			width: 100%;
			${({theme, $small}) =>
				$small ? theme.font.extra_small : theme.font.small};
			padding: ${({$small}) => ($small ? '4px 0' : '0')};

			&::placeholder {
				color: ${({theme}) => theme.color.grey3};
			}
		}

		& > div {
			width: fit-content;
		}
	`,
}
